import axiosInstance from '../../../config/axiosInstance';
const PurchaseOrderService = {
    async GetAllPurchaseOrders(redirectCallback, ClientCompanyID, SupplierID,Start, PageSize, searchQuery, sortColumn, sortDirection,SearchColumns) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/PurchaseOrder/GetPurchaseOrders?ClientID=${ClientID}&ClientCompanyID=${ClientCompanyID}&SupplierID=${SupplierID}&Start=${Start}&PageSize=${PageSize}&searchQuery=${searchQuery}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&UserID=${UserID}&SearchColumns=${SearchColumns}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetPurchaseOrderCount(redirectCallback, ClientCompanyID, SupplierID,searchQuery,SearchColumns) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/PurchaseOrder/GetPurchaseOrderCount?ClientID=${ClientID}&ClientCompanyID=${ClientCompanyID}&SupplierID=${SupplierID}&searchQuery=${searchQuery}&UserID=${UserID}&SearchColumns=${SearchColumns}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetAllParts(redirectCallback,SupplierID=0) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const ClientCompanyID=0;
            const response = await axiosInstance.get(`/Part/GetAllParts?ClientID=${ClientID}&ClientCompanyID=${ClientCompanyID}&SupplierID=${SupplierID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetPurchaseOrderByID(redirectCallback, ID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/PurchaseOrder/GetPurchaseOrderByID?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },

    async GetPurchaseOrderItem(redirectCallback, ID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/PurchaseOrder/GetPurchaseOrderItem?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },

    async DeletePurchaseOrder(ID, redirectCallback) {
        try {
            const idString = ID.join(',');
            const response = await axiosInstance.get(`/PurchaseOrder/DeletePurchaseOrder?ID=${idString}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async OrderPurchaseOrder(event, formData) {
        try {
            event.preventDefault();
            const CompanyID = localStorage.getItem("CompanyID");
            formData.formData.ClientID = CompanyID;
            const UserID = localStorage.getItem("UserID");
            formData.formData.UserID = UserID;
            const response = await axiosInstance.post(`/PurchaseOrder/OrderPurchaseOrder`, formData);
            debugger;
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async DeliverPurchaseOrder(event, formData) {
        try {
            event.preventDefault();
            const CompanyID = localStorage.getItem("CompanyID");
            formData.formData.ClientID = CompanyID;
            const UserID = localStorage.getItem("UserID");
            formData.formData.UserID = UserID;
            const response = await axiosInstance.post(`/PurchaseOrder/DeliverPurchaseOrder`, formData);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async GetPurchaseHistory(redirectCallback, PurchaseOrderID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/PurchaseOrder/GetPurchaseHistory?PurchaseOrderID=${PurchaseOrderID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async CompletePOrder(PurchaseOrderID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/PurchaseOrder/CompletePOrder?PurchaseOrderID=${PurchaseOrderID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async LockPurchaseOrder(ID) {
        try {
            const UserID = localStorage.getItem("UserID");
            const response = await axiosInstance.get(`/PurchaseOrder/LockPurchaseOrder?ID=${ID}&UserID=${UserID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async UnLockPurchaseOrder(ID) {
        try {
            const UserID = localStorage.getItem("UserID");
            const response = await axiosInstance.get(`/PurchaseOrder/UnLockPurchaseOrder?ID=${ID}&UserID=${UserID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
};

export default PurchaseOrderService;